import firebaseKit from "../firebase/firebaseKit";
import ChatMessage from "./ChatMessage";
import { ChatMessageEnums } from "./index";
import { refs, getRef } from "../firebase/firebaseRefKit";

export default class CorporateChatMessage extends ChatMessage {
  constructor({
    me = null,
    payload: {
      author,
      epoch = firebaseKit.util.getServerTimestamp(),
      message = "",
      timeStamp = new Date().toGMTString(),
      videoRoomSlug = null,
      kind = ChatMessageEnums.TEXT,
      isAgent = false,
    },

    options = {},

    urlParams: {
      organizationSlug,
      pageSlug,
      eventSlug,
      eventUserId,
      firebaseID,
    },
  }) {
    super(options);

    if (me && !options.isAgent) {
      this.author = {
        displayName: this._getDisplayName(me),
        userId: me?.user?.id,
        eventUserId: me?.id,
      };
    } else if (me && options.isAgent) {
      this.author = {
        displayName: me.displayName,
        title: me.title,
        userId: me.user.id,
      };
    } else if (author) {
      this.author = this._camelCaseify(author);
    } else {
      throw new Error("No author specified for message");
    }

    this.videoRoomSlug = options.videoRoomSlug || videoRoomSlug;

    this.message = message;
    this.epoch = epoch;
    this.timeStamp = timeStamp;
    this.kind = options.kind || kind;
    this.isAgent = options.isAgent ?? isAgent;

    this._urlParams = {
      organizationSlug,
      pageSlug,
      eventSlug,
      eventUserId,
      firebaseID,
    };

    this.type = "corporate";
  }

  _getInboxRef() {
    const { eventUserId } = this._urlParams;
    if (!eventUserId)
      throw new Error(
        "Can't get Firebase ref without organizationSlug and pageSlug"
      );
    const ref = getRef(
      refs["corporate-messages"].$organizationSlug.$eventSlug.inboxes.$pageSlug
        .$eventUserId.messages,
      this._urlParams
    );
    if (ref) return ref;
  }

  _getInboxBaseUrl() {
    const { organizationSlug, pageSlug, eventSlug } = this._urlParams;
    return `corporate-messages/${organizationSlug}/${eventSlug}/inboxes/${pageSlug}`;
  }

  _getPayload() {
    const {
      author,
      message,
      epoch,
      timeStamp,
      isAgent,
      videoRoomSlug,
    } = this;

    let payload = {
      author,
      message,
      epoch,
      timeStamp,
      isAgent,
    };

    if (videoRoomSlug) payload.videoRoomSlug = videoRoomSlug;

    return payload;
  }
}
